module.exports = {
	"permanent": "Permanente",
	"buttons": {
		"cancel": "Cancelar",
		"close": "Fechar",
		"copy": "Copiar",
		"copyFile": "Copiar arquivo",
		"copyToClipboard": "Copiar",
		"create": "Criar",
		"delete": "Eliminar",
		"download": "Baixar",
		"info": "Info",
		"more": "Mais",
		"move": "Mover",
		"moveFile": "Mover arquivo",
		"new": "Novo",
		"next": "Próximo",
		"ok": "OK",
		"previous": "Anterior",
		"publish": "Publicar",
		"rename": "Renomear",
		"replace": "Substituir",
		"reportIssue": "Reportar Erro",
		"save": "Salvar",
		"share": "Compartilhar",
		"schedule": "Agendar",
		"search": "Pesquisar",
		"select": "Selecionar",
		"selectMultiple": "Selecionar múltiplos",
		"switchView": "Alterar modo de visão",
		"toggleSidebar": "Alternar barra lateral",
		"update": "Atualizar",
		"upload": "Enviar",
		"permalink": "Obter link permanente"
	},
	"success": {
		"linkCopied": "Link copiado!"
	},
	"errors": {
		"forbidden": "Você não é bem-vindo aqui.",
		"internal": "Algo de ruim ocorreu.",
		"notFound": "Não conseguimos chegar a esta localização."
	},
	"files": {
		"body": "Corpo",
		"clear": "Limpar",
		"closePreview": "Fechar pré-visualização",
		"files": "Arquivos",
		"folders": "Pastas",
		"home": "Início",
		"lastModified": "Última modificação",
		"loading": "Carregando...",
		"lonely": "Sinto-me sozinho...",
		"metadata": "Metadados",
		"multipleSelectionEnabled": "Seleção múltipla ativada",
		"name": "Nome",
		"size": "Tamanho",
		"sortByLastModified": "Ordenar pela última modificação",
		"sortByName": "Ordenar pelo nome",
		"sortBySize": "Ordenar pelo tamanho"
	},
	"help": {
		"click": "selecionar pasta ou arquivo",
		"ctrl": {
			"click": "selecionar várias pastas e arquivos",
			"f": "pesquisar",
			"s": "salvar um arquivo ou baixar a pasta que você está"
		},
		"del": "eliminar os arquivos selecionados",
		"doubleClick": "abrir pasta ou arquivo",
		"esc": "limpar seleção e/ou fechar menu",
		"f1": "esta informação",
		"f2": "renomear arquivo",
		"help": "Ajuda"
	},
	"languages": {
		"en": "English",
		"fr": "Français",
		"pt": "Português",
		"ptBR": "Português (Brasil)",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"ru": "Русский"
	},
	"login": {
		"password": "Senha",
		"submit": "Login",
		"username": "Nome do usuário",
		"wrongCredentials": "Dados errados"
	},
	"prompts": {
		"copy": "Copiar",
		"copyMessage": "Escolhe um lugar para copiar os arquivos:",
		"currentlyNavigating": "Navegando em:",
		"deleteMessageMultiple": "Deseja eliminar {count} arquivo(s)?",
		"deleteMessageSingle": "Deseja eliminar esta pasta/arquivo?",
		"deleteTitle": "Eliminar arquivos",
		"displayName": "Nome:",
		"download": "Baixar arquivos",
		"downloadMessage": "Escolha o formato do arquivo.",
		"error": "Algo de ruim ocorreu",
		"fileInfo": "Informação do arquivo",
		"filesSelected": "{count} arquivos selecionados.",
		"lastModified": "Última Modificação",
		"move": "Mover",
		"moveMessage": "Escolha uma nova casa para os seus arquivos:",
		"newArchetype": "Criar um novo post baseado num \"archetype\". O seu arquivo será criado na pasta \"content\".",
		"newDir": "Nova pasta",
		"newDirMessage": "Escreva o nome da nova pasta.",
		"newFile": "Novo arquivo",
		"newFileMessage": "Escreva o nome do novo arquivo.",
		"numberDirs": "Número de pastas",
		"numberFiles": "Número de arquivos",
		"rename": "Renomear",
		"renameMessage": "Insira um novo nome para",
		"replace": "Substituir",
		"replaceMessage": "Já existe um arquivo com nome igual a um dos que está tentando enviar. Deseja substituir?\n",
		"schedule": "Agendar",
		"scheduleMessage": "Escolha uma data para publicar este post.",
		"show": "Mostrar",
		"size": "Tamanho"
	},
	"search": {
		"images": "Imagens",
		"music": "Música",
		"pdf": "PDF",
		"pressToExecute": "Pressione enter para executar.",
		"pressToSearch": "Pressione enter para pesquisar.",
		"search": "Pesquise...",
		"searchOrCommand": "Pesquise ou execute um comando...",
		"searchOrSupportedCommand": "Pesquise ou utilize um dos seus comandos:",
		"type": "Escreva e pressione enter para pesquisar.",
		"types": "Tipos",
		"video": "Vídeos",
		"writeToSearch": "Escreva aqui para pesquisar"
	},
	"settings": {
		"admin": "Admin",
		"administrator": "Administrador",
		"allowCommands": "Executar comandos",
		"allowEdit": "Editar, renomear e eliminar arquivos ou pastas",
		"allowNew": "Criar novos arquivos e pastas",
		"allowPublish": "Publicar novas páginas e conteúdos",
		"avoidChanges": "(deixe em branco para manter)",
		"changePassword": "Alterar Senha",
		"commands": "Comandos",
		"commandsHelp": "Pode definir um conjunto de comandos a executar em determiandos eventos. Deve escrever um comando por linha. Se o evento estiver relacionado com arquivos, como antes e depois de salvar, irá existir uma variável de ambiente denominada \"FILE\" com o caminho do arquivo.\n",
		"commandsUpdated": "Comandos atualizados!",
		"customStylesheet": "Estilos Personalizados",
		"examples": "Exemplos",
		"globalSettings": "Configurações Globais",
		"language": "Linguagem",
		"lockPassword": "Não permitir que o usuário altere a senha",
		"newPassword": "Nova senha",
		"newPasswordConfirm": "Confirme a nova senha",
		"newUser": "Novo Usuário",
		"password": "Senha",
		"passwordUpdated": "Senha atualizada!",
		"permissions": "Permissões",
		"permissionsHelp": "Pode definir o usuário como administrador ou escolher as permissões manualmente. Se selecionar a opção \"Administrador\", todas as outras opções serão automaticamente selecionadas. A gestão dos usuários é um privilégio restringido aos administradores.\n",
		"profileSettings": "Configurações do Usuário",
		"ruleExample1": "previne o acesso a qualquer \"dotfile\" (como .git, .gitignore) em qualquer pasta\n",
		"ruleExample2": "bloqueia o acesso ao arquivo chamado Caddyfile.",
		"rules": "Regras",
		"rulesHelp1": "Aqui pode definir um conjunto de regras para permitir ou bloquear o acesso do utilizador a determinados arquivos ou pastas. Os arquivos bloqueados não irão aparecer durante a navegação. Suportamos expressões regulares e os caminhos dos arquivos devem ser relativos à base do usuário.\n",
		"rulesHelp2": "Cada regra deve ser colocada numa linha diferente e deve começar com as palavras {0} (permite) ou {1} (bloqueia). Deve escrever, logo de seguida, {2}, caso queira utilizar uma expressão regular. Depois, escreva o caminho do arquivo/pasta ou a expressão regular.\n",
		"scope": "Base",
		"settingsUpdated": "Configurações atualizadas!",
		"user": "Usuário",
		"userCommands": "Comandos",
		"userCommandsHelp": "Uma lista, separada com espaços, de comandos disponíveis para este usuário. Exemplo:",
		"userCreated": "Usuário criado!",
		"userDeleted": "Usuário eliminado!",
		"userManagement": "Gestão de Usuários",
		"username": "Nome do usuário",
		"users": "Usuários",
		"userUpdated": "Usuário atualizado!"
	},
	"sidebar": {
		"help": "Ajuda",
		"hugoNew": "Hugo New",
		"logout": "Sair",
		"myFiles": "Arquivos",
		"newFile": "Novo arquivo",
		"newFolder": "Nova pasta",
		"preview": "Pré-visualizar",
		"settings": "Configurações",
		"siteSettings": "Configurações do Site"
	},
	"time": {
		"unit": "Unidades de Tempo",
		"seconds": "Segundos",
		"minutes": "Minutos",
		"hours": "Horas",
		"days": "Dias"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/pt-br.yaml
// module id = 289
// module chunks = 0